import { render, staticRenderFns } from "./OurClients.vue?vue&type=template&id=6b120d86&"
import script from "./OurClients.vue?vue&type=script&lang=js&"
export * from "./OurClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports